import React from 'react';
import PropTypes from 'prop-types';
import { Spreadsheet as SpreadsheetBase } from 'dhtmlx-spreadsheet';
import 'dhtmlx-spreadsheet/codebase/spreadsheet.css';
import './Spreadsheet.scss';

class Spreadsheet extends React.Component {
    componentDidMount() {
        this.spreadsheet = new SpreadsheetBase(this.el, {
            menu: this.props.menu,
            editLine: this.props.editLine,
            toolbarBlocks: this.props.toolbarBlocks,
            colsCount: this.props.colsCount,
            multiSheets: this.props.multiSheets,
            rowsCount: this.props.rowsCount
          });
    }

    componentWillUnmount() {
        this.spreadsheet.destructor();
    }

    render() {
        return (
            <div ref={el => this.el = el} className="widget-box"></div>
          );
    }
}

Spreadsheet.propTypes = {
    menu: PropTypes.bool,
    editLine: PropTypes.bool,
    toolbarBlocks: PropTypes.array,
    colsCount: PropTypes.number,
    rowsCount: PropTypes.number,
    multiSheets: PropTypes.bool
  };  

export default Spreadsheet;